import React, { useState, useRef, useEffect } from 'react';

const Tabs = ({ tabs, selectedIndex = 0, onTabChange, children, divBorder = true,disabledTabs = [] }) => {
  const [activeTab, setActiveTab] = useState(selectedIndex);

  useEffect(() => {
    setActiveTab(selectedIndex);
  }, [selectedIndex]);

  const handleTabClick = (index) => {
    if (disabledTabs.includes(index)) return;
    setActiveTab(index);
    if (onTabChange) {
      onTabChange(index);
    }
  };

  return (
    <div>
      {/* Tab Headers */}
      <div className="tab-container">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={activeTab === index ? 'tab active-tab' : 'tab'}
            onClick={() => handleTabClick(index)}
            disabled={disabledTabs.includes(index)}
            style={disabledTabs.includes(index) ? { color: '#666', cursor: 'not-allowed', opacity: 0.5} : {}}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {divBorder ?
        <div className="content-container">
          {children[activeTab]}
        </div>
        : <div>
          {children[activeTab]}
        </div>}

    </div>
  );
};

export default Tabs;
